import { makeStyles } from '@material-ui/core/styles';

export const useDebitStyles = makeStyles(() => ({
  title: {
    fontSize: 26,
    textAlign: 'center',
    marginBottom: 35,
    color: '#464646',
  },
  info: {
    marginBottom: 15,
  },
}));
